export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  link: (name) => `nav-link-${name}`,
  callCta: "nav-call-cta",
  mobileToggle: "nav-mobile-toggle",
  mobilePanel: "nav-mobile-panel",
  mobileLink: (name) => `nav-mobile-link-${name}`,
};

export const FOOTER = {
  root: "footer-root",
  phone: "footer-phone",
  email: "footer-email",
  address: "footer-address",
  link: (name) => `footer-link-${name}`,
};

export const HOME_PAGE = {
  hero: "home-hero",
  heroCtaPrimary: "home-hero-cta-primary",
  heroCtaSecondary: "home-hero-cta-secondary",
  trustBar: "home-trust-bar",
  whyChooseUs: "home-why-choose-us",
  servicesGrid: "home-services-grid",
  serviceCard: (slug) => `home-service-card-${slug}`,
  testimonials: "home-testimonials",
  finalCta: "home-final-cta",
};

export const ABOUT_PAGE = {
  root: "about-root",
  mission: "about-mission",
  values: "about-values",
  cqc: "about-cqc",
};

export const SERVICES_PAGE = {
  root: "services-root",
  card: (slug) => `services-card-${slug}`,
};

export const CAREERS_PAGE = {
  root: "careers-root",
  applyCta: "careers-apply-cta",
  trainingItem: (slug) => `careers-training-${slug}`,
};

export const CONTACT_PAGE = {
  root: "contact-root",
  phone: "contact-phone",
  email: "contact-email",
  address: "contact-address",
  hours: "contact-hours",
  form: "contact-form",
  formName: "contact-form-name",
  formPhone: "contact-form-phone",
  formEmail: "contact-form-email",
  formCare: "contact-form-care",
  formTime: "contact-form-time",
  formMessage: "contact-form-message",
  formSubmit: "contact-form-submit",
  formSuccess: "contact-form-success",
  formError: "contact-form-error",
};
